(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amoni-collection-circles"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Swiper is loaded once from a CDN and shared by every instance of this
     section on the page. Guards against double-loading the script/CSS. */
  function loadSwiperLib(callback) {
    if (window.Swiper) { callback(); return; }
    window.__swiperCallbacks = window.__swiperCallbacks || [];
    window.__swiperCallbacks.push(callback);
    if (window.__swiperLoading) return;
    window.__swiperLoading = true;
    if (!document.querySelector('link[data-swiper-css]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      link.setAttribute('data-swiper-css', '');
      document.head.appendChild(link);
    }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = function() {
      (window.__swiperCallbacks || []).forEach(function(cb) { cb(); });
      window.__swiperCallbacks = [];
    };
    document.head.appendChild(script);
  }

  function initCircles(section) {
    var row = section.querySelector('[data-circles-row]');
    var track = section.querySelector('[data-circles-track]');
    if (!row || !track) return;
    var slides = track.querySelectorAll('[data-circles-item]');
    var mq = window.matchMedia('(max-width: 749px)');
    var swiper = null;

    function shouldSlide() {
      return mq.matches && slides.length > 4;
    }

    function enableSwiper() {
      if (swiper) return;
      row.classList.add('swiper');
      track.classList.add('swiper-wrapper');
      slides.forEach(function(s) { s.classList.add('swiper-slide'); });
      loadSwiperLib(function() {
        if (swiper || !shouldSlide()) return;
        swiper = new Swiper(row, {
          slidesPerView: 4,
          spaceBetween: 20,
          watchOverflow: true
        });
      });
    }

    function disableSwiper() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
      row.classList.remove('swiper');
      track.classList.remove('swiper-wrapper');
      slides.forEach(function(s) { s.classList.remove('swiper-slide'); });
    }

    function update() {
      if (shouldSlide()) {
        enableSwiper();
      } else {
        disableSwiper();
      }
    }

    update();
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else {
      mq.addListener(update);
    }
  }

  document.querySelectorAll('.section-collection-circles').forEach(initCircles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amoni-collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Swiper is already loaded globally from theme.liquid - do not load it
     here again. */

  function initTabs(section) {
    var btns = section.querySelectorAll('[data-tab-btn]');
    var panels = section.querySelectorAll('[data-tab-panel]');
    var progressBar = section.querySelector('[data-tabs-progress-bar]');
    var prevArrow = section.querySelector('[data-tabs-prev]');
    var nextArrow = section.querySelector('[data-tabs-next]');
    var arrowsWrap = section.querySelector('[data-tabs-arrows]');
    var sliders = []; /* { grid, swiper } */

    function sliderFor(grid) {
      var found = null;
      sliders.forEach(function(s) { if (s.grid === grid) found = s; });
      return found;
    }

    function updateArrowsFor(swiper) {
      if (!prevArrow || !nextArrow) return;
      if (swiper.isLocked) {
        if (arrowsWrap) arrowsWrap.classList.add('is-hidden');
        return;
      }
      if (arrowsWrap) arrowsWrap.classList.remove('is-hidden');
      prevArrow.disabled = swiper.isBeginning;
      nextArrow.disabled = swiper.isEnd;
    }

    function buildSlider(grid) {
      if (!window.Swiper) return null;
      var lg = parseFloat(grid.getAttribute('data-slides-lg')) || 4;
      var md = parseFloat(grid.getAttribute('data-slides-md')) || lg;
      var mobile = parseFloat(grid.getAttribute('data-slides-mobile')) || 1.2;
      var swiper = new Swiper(grid, {
        slidesPerView: mobile,
        spaceBetween: 10,
        watchOverflow: true,
        breakpoints: {
          750: { slidesPerView: md, spaceBetween: 16 },
          990: { slidesPerView: lg, spaceBetween: 20 }
        }
      });
      swiper.on('slideChange', function() { updateArrowsFor(swiper); });
      swiper.on('reachBeginning', function() { updateArrowsFor(swiper); });
      swiper.on('reachEnd', function() { updateArrowsFor(swiper); });
      swiper.on('fromEdge', function() { updateArrowsFor(swiper); });
      if (progressBar) {
        swiper.on('progress', function(sw, progress) {
          var pct = Math.max(0, Math.min(1, progress)) * 100;
          progressBar.style.width = pct + '%';
        });
      }
      return swiper;
    }

    function activeEntry() {
      var panel = section.querySelector('.tabs__panel.is-active');
      if (!panel) return null;
      var grid = panel.querySelector('.tabs__grid');
      if (!grid) return null;
      return sliderFor(grid);
    }

    function refreshActive() {
      var entry = activeEntry();
      if (!entry) return;
      if (!entry.swiper) {
        entry.swiper = buildSlider(entry.grid);
      }
      if (entry.swiper) {
        entry.swiper.update();
        updateArrowsFor(entry.swiper);
      } else if (arrowsWrap) {
        arrowsWrap.classList.add('is-hidden');
      }
    }

    section.querySelectorAll('.tabs__grid').forEach(function(grid) {
      sliders.push({ grid: grid, swiper: null });
    });

    if (prevArrow) prevArrow.addEventListener('click', function() {
      var entry = activeEntry();
      if (entry && entry.swiper) entry.swiper.slidePrev();
    });
    if (nextArrow) nextArrow.addEventListener('click', function() {
      var entry = activeEntry();
      if (entry && entry.swiper) entry.swiper.slideNext();
    });

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.tabBtn);
        btns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected','true');
        var panel = section.querySelector('[data-tab-panel="' + idx + '"]');
        if (panel) panel.classList.add('is-active');
        refreshActive();
      });
    });

    refreshActive();
    window.addEventListener('load', refreshActive);
    window.addEventListener('resize', function() {
      var entry = activeEntry();
      if (entry && entry.swiper) updateArrowsFor(entry.swiper);
    });
  }

  function initSwatches(section) {
    var cards = section.querySelectorAll('.tabs__product-card');

    cards.forEach(function(card) {
      var imageWrap = card.querySelector('.tabs__product-image');
      var swatches = card.querySelectorAll('.tabs__swatch');

      function setImage(src) {
        /* look up the <img> fresh every time - some themes swap/replace the
           image element after lazy-load, so a reference cached at page-load
           can go stale. Target the stable wrapper instead of our own class,
           in case another script rewrites the img's className. */
        var img = imageWrap && imageWrap.querySelector('img');
        if (src && img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', src);
          img.src = src;
        }
      }

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          swatches.forEach(function(s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');

          /* preview only - the card's own link/URL is intentionally left
             pointing at the current product, it does not follow the swatch */
          var newImage = swatch.dataset.image;
          var newUrl = swatch.dataset.url;

          if (newImage) {
            setImage(newImage);
          } else if (newUrl) {
            /* fall back to fetching the linked product's own image directly,
               in case the swatch's image metafield wasn't populated */
            fetch(newUrl + '.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(p) {
                var src = p && (p.featured_image || (p.images && p.images[0]));
                if (src) setImage(src.indexOf('?') > -1 ? src + '&width=600' : src + '?width=600');
              })
              .catch(function() {});
          }
        });
      });
    });
  }

  function initCartActions(section) {
    var cartStyle = (section.getAttribute('data-cart-style') || 'drawer').toLowerCase();
    var addUrl = section.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = section.getAttribute('data-cart-url') || '/cart';

    function openCartDrawer(added) {
      fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          if (cartStyle === 'pop') {
            document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: added }, bubbles: true }));
          } else {
            var drawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (drawer) {
              drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
            } else {
              document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: added }, bubbles: true }));
            }
          }
        })
        .catch(function() { window.location.href = cartUrl; });
    }

    function addToCart(variantId, callback) {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd
      })
        .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
        .then(function(res) { callback(res.ok, res.data); })
        .catch(function() { callback(false, null); });
    }

    section.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || !section.contains(btn)) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid || btn.disabled) return;
      btn.disabled = true;
      addToCart(vid, function(ok, data) {
        btn.disabled = false;
        if (!ok) return;
        if (cartStyle === 'page' || cartStyle === 'compatible') { window.location.href = cartUrl; return; }
        openCartDrawer(data);
      });
    });

    section.querySelectorAll('[data-quickview-modal]').forEach(function(dialog) {
      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) dialog.close();
      });

      var sizeBtns = dialog.querySelectorAll('.tabs__qv-size-btn');
      var atcBtn = dialog.querySelector('[data-qv-atc]');
      var atcText = dialog.querySelector('[data-qv-atc-text]');
      var priceEl = dialog.querySelector('[data-qv-price]');
      var sizeNameEl = dialog.querySelector('[data-qv-size-name]');

      sizeBtns.forEach(function(sizeBtn) {
        sizeBtn.addEventListener('click', function() {
          if (sizeBtn.disabled) return;
          sizeBtns.forEach(function(b) { b.classList.remove('is-selected'); });
          sizeBtn.classList.add('is-selected');
          var vid = sizeBtn.getAttribute('data-variant-id');
          if (sizeNameEl) sizeNameEl.textContent = sizeBtn.getAttribute('data-title');
          if (priceEl) {
            var onSale = sizeBtn.getAttribute('data-on-sale') === 'true';
            var price = sizeBtn.getAttribute('data-price');
            var comparePrice = sizeBtn.getAttribute('data-compare-price');
            priceEl.innerHTML = onSale
              ? '<span class="tabs__price tabs__price--sale">' + price + '</span><span class="tabs__price tabs__price--compare">' + comparePrice + '</span>'
              : price;
          }
          if (atcBtn) {
            atcBtn.setAttribute('data-variant-id', vid);
            atcBtn.disabled = false;
          }
          if (atcText) atcText.textContent = 'Add to cart';
        });
      });

      if (atcBtn) {
        atcBtn.addEventListener('click', function() {
          var vid = atcBtn.getAttribute('data-variant-id');
          if (!vid || atcBtn.disabled) return;
          atcBtn.disabled = true;
          atcBtn.classList.add('is-loading');
          addToCart(vid, function(ok, data) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-loading');
            if (!ok) return;
            dialog.close();
            if (cartStyle === 'page' || cartStyle === 'compatible') { window.location.href = cartUrl; return; }
            openCartDrawer(data);
          });
        });
      }

      var colorNameEl = dialog.querySelector('[data-qv-color-name]');
      var colorSwatches = dialog.querySelectorAll('.tabs__qv-swatch');
      if (colorNameEl && colorSwatches.length) {
        var defaultColorName = colorNameEl.textContent;
        colorSwatches.forEach(function(sw) {
          sw.addEventListener('mouseenter', function() {
            colorNameEl.textContent = sw.getAttribute('title') || defaultColorName;
          });
          sw.addEventListener('mouseleave', function() {
            colorNameEl.textContent = defaultColorName;
          });
        });
      }
    });

    section.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-quickview-open]');
      if (openBtn && section.contains(openBtn)) {
        e.preventDefault();
        var targetId = openBtn.getAttribute('data-quickview-target');
        var dialog = section.querySelector('#' + CSS.escape(targetId));
        if (dialog && dialog.showModal) dialog.showModal();
        return;
      }
      var closeBtn = e.target.closest('[data-quickview-close]');
      if (closeBtn && section.contains(closeBtn)) {
        e.preventDefault();
        var openDialog = closeBtn.closest('[data-quickview-modal]');
        if (openDialog) openDialog.close();
      }
    });
  }

  document.querySelectorAll('.section-collection-tabs').forEach(function(section) {
    initTabs(section);
    initSwatches(section);
    initCartActions(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amoni-featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Swiper is already loaded globally from theme.liquid - do not load it here again. */
  function initMobileSlider(section) {
    var grid = section.querySelector('.prod-grid__grid.swiper');
    if (!grid) return;

    var mobileMql = window.matchMedia('(max-width: 749px)');
    var slider = null;

    function build() {
      if (!window.Swiper || slider) return;
      slider = new Swiper(grid, {
        slidesPerView: parseFloat(grid.getAttribute('data-slides-mobile')) || 1.5,
        spaceBetween: 12,
        watchOverflow: true,
        preventClicks: false,
        preventClicksPropagation: false
      });
    }

    function destroy() {
      if (!slider) return;
      slider.destroy(true, true);
      slider = null;
    }

    function sync() {
      if (mobileMql.matches) {
        build();
      } else {
        destroy();
      }
    }

    sync();
    mobileMql.addEventListener('change', sync);
  }

  function initSwatches(section) {
    var cards = section.querySelectorAll('.prod-grid__card');

    cards.forEach(function(card) {
      var frame = card.querySelector('.prod-grid__photo-frame');
      var swatches = card.querySelectorAll('.prod-grid__swatch');

      function setImage(src) {
        /* Select by structure (first <img> inside the photo frame's link),
           not by our own "prod-grid__img" class - some other script on this
           theme rewrites/replaces that class after load, so relying on it
           made the lookup fail silently. The base photo is always the first
           <img>; the hover-swap photo (if any) is appended after it. */
        var img = frame && frame.querySelector('.prod-grid__image-link img');
        if (src && img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', src);
          img.src = src;
        }
      }

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          swatches.forEach(function(s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');

          /* preview only - the card's own link/URL is intentionally left
             pointing at the current product, it does not follow the swatch */
          var newImage = swatch.dataset.image;
          var newUrl = swatch.dataset.url;

          if (newImage) {
            setImage(newImage);
          } else if (newUrl) {
            /* fall back to fetching the linked product's own image directly,
               in case the swatch's image metafield wasn't populated */
            fetch(newUrl + '.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(p) {
                var src = p && (p.featured_image || (p.images && p.images[0]));
                if (src) setImage(src.indexOf('?') > -1 ? src + '&width=600' : src + '?width=600');
              })
              .catch(function() {});
          }
        });
      });
    });
  }

  function initCartActions(section) {
    var cartStyle = (section.getAttribute('data-cart-style') || 'drawer').toLowerCase();
    var addUrl = section.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = section.getAttribute('data-cart-url') || '/cart';

    function openCartDrawer(added) {
      fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          if (cartStyle === 'pop') {
            document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: added }, bubbles: true }));
          } else {
            var drawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (drawer) {
              drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
            } else {
              document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: added }, bubbles: true }));
            }
          }
        })
        .catch(function() { window.location.href = cartUrl; });
    }

    function addToCart(variantId, callback) {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd
      })
        .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
        .then(function(res) { callback(res.ok, res.data); })
        .catch(function() { callback(false, null); });
    }

    section.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || !section.contains(btn)) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid || btn.disabled) return;
      btn.disabled = true;
      addToCart(vid, function(ok, data) {
        btn.disabled = false;
        if (!ok) return;
        if (cartStyle === 'page' || cartStyle === 'compatible') { window.location.href = cartUrl; return; }
        openCartDrawer(data);
      });
    });

    section.querySelectorAll('[data-quickview-modal]').forEach(function(dialog) {
      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) dialog.close();
      });

      var sizeBtns = dialog.querySelectorAll('.prod-grid__qv-size-btn');
      var atcBtn = dialog.querySelector('[data-qv-atc]');
      var atcText = dialog.querySelector('[data-qv-atc-text]');
      var priceEl = dialog.querySelector('[data-qv-price]');
      var sizeNameEl = dialog.querySelector('[data-qv-size-name]');

      sizeBtns.forEach(function(sizeBtn) {
        sizeBtn.addEventListener('click', function() {
          if (sizeBtn.disabled) return;
          sizeBtns.forEach(function(b) { b.classList.remove('is-selected'); });
          sizeBtn.classList.add('is-selected');
          var vid = sizeBtn.getAttribute('data-variant-id');
          if (sizeNameEl) sizeNameEl.textContent = sizeBtn.getAttribute('data-title');
          if (priceEl) {
            var onSale = sizeBtn.getAttribute('data-on-sale') === 'true';
            var price = sizeBtn.getAttribute('data-price');
            var comparePrice = sizeBtn.getAttribute('data-compare-price');
            priceEl.innerHTML = onSale
              ? '<span class="prod-grid__price prod-grid__price--sale">' + price + '</span><span class="prod-grid__price prod-grid__price--was">' + comparePrice + '</span>'
              : price;
          }
          if (atcBtn) {
            atcBtn.setAttribute('data-variant-id', vid);
            atcBtn.disabled = false;
          }
          if (atcText) atcText.textContent = 'Add to cart';
        });
      });

      if (atcBtn) {
        atcBtn.addEventListener('click', function() {
          var vid = atcBtn.getAttribute('data-variant-id');
          if (!vid || atcBtn.disabled) return;
          atcBtn.disabled = true;
          atcBtn.classList.add('is-loading');
          addToCart(vid, function(ok, data) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-loading');
            if (!ok) return;
            dialog.close();
            if (cartStyle === 'page' || cartStyle === 'compatible') { window.location.href = cartUrl; return; }
            openCartDrawer(data);
          });
        });
      }

      var colorNameEl = dialog.querySelector('[data-qv-color-name]');
      var colorSwatches = dialog.querySelectorAll('.prod-grid__qv-swatch');
      if (colorNameEl && colorSwatches.length) {
        var defaultColorName = colorNameEl.textContent;
        colorSwatches.forEach(function(sw) {
          sw.addEventListener('mouseenter', function() {
            colorNameEl.textContent = sw.getAttribute('title') || defaultColorName;
          });
          sw.addEventListener('mouseleave', function() {
            colorNameEl.textContent = defaultColorName;
          });
        });
      }
    });

    section.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-quickview-open]');
      if (openBtn && section.contains(openBtn)) {
        e.preventDefault();
        var targetId = openBtn.getAttribute('data-quickview-target');
        var dialog = section.querySelector('#' + CSS.escape(targetId));
        if (dialog && dialog.showModal) dialog.showModal();
        return;
      }
      var closeBtn = e.target.closest('[data-quickview-close]');
      if (closeBtn && section.contains(closeBtn)) {
        e.preventDefault();
        var openDialog = closeBtn.closest('[data-quickview-modal]');
        if (openDialog) openDialog.close();
      }
    });
  }

  document.querySelectorAll('.section-collection').forEach(function(section) {
    initMobileSlider(section);
    initSwatches(section);
    initCartActions(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amoni-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initHeroSlider(section) {
    var slider = section.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.hero__slide');
    var dots = section.querySelectorAll('[data-hero-dot]');
    var prevBtn = section.querySelector('[data-hero-prev]');
    var nextBtn = section.querySelector('[data-hero-next]');
    if (slides.length <= 1) {
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }
    var current = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.speed) || 5000;
    var timer = null;
    dots.forEach(function(dot) {
      dot.style.setProperty('--dot-duration', speed + 'ms');
    });
    function restartDotProgress(dot) {
      if (!dot || !autoplay) return;
      dot.classList.remove('has-progress');
      // force reflow so the animation restarts from 0%
      void dot.offsetWidth;
      dot.classList.add('has-progress');
    }
    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active', 'has-progress');
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        restartDotProgress(dots[current]);
      }
    }
    slides[0].classList.add('is-active');
    if (dots[0]) {
      dots[0].classList.add('is-active');
      restartDotProgress(dots[0]);
    }
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); restartAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); restartAuto(); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.heroDot)); restartAuto(); });
    });
    function startAuto() {
      if (!autoplay) return;
      timer = setInterval(function() { goTo(current + 1); }, speed);
    }
    function stopAuto() {
      clearInterval(timer);
      timer = null;
    }
    function restartAuto() {
      stopAuto();
      startAuto();
    }
    function pauseDots() {
      if (dots[current]) dots[current].classList.add('is-paused');
    }
    function resumeDots() {
      if (dots[current]) {
        dots[current].classList.remove('is-paused');
        restartDotProgress(dots[current]);
      }
    }
    slider.addEventListener('mouseenter', function() { stopAuto(); pauseDots(); });
    slider.addEventListener('mouseleave', function() { resumeDots(); startAuto(); });
    startAuto();
  }
  document.querySelectorAll('.section-hero').forEach(initHeroSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toolbar-topbar"]) return;
  try {
    
    (function () {
      function bindSearch(root) {
        root.querySelectorAll('[data-country-search]').forEach(function (input) {
          if (input.dataset.searchBound) return;
          input.dataset.searchBound = 'true';

          var list = input.closest('.popout-list');
          if (!list) return;
          var items = list.querySelectorAll('[data-country-option-item]');

          input.addEventListener('input', function () {
            var query = input.value.trim().toLowerCase();
            items.forEach(function (item) {
              var match = item.getAttribute('data-search-value').indexOf(query) !== -1;
              item.hidden = !match;
            });
          });

          input.addEventListener('keydown', function (evt) {
            if (evt.key === 'Enter') evt.preventDefault();
          });
        });
      }

      function init(root) {
        bindSearch(root);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          init(document);
        });
      } else {
        init(document);
      }

      document.addEventListener('shopify:section:load', function (evt) {
        init(evt.target);
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukj-trust"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTrustSlider(section) {
      var grid = section.querySelector('.ukj-tp__list');
      var prevArrow = section.querySelector('[data-ukj-prev]');
      var nextArrow = section.querySelector('[data-ukj-next]');
      if (!grid) return;

      function updateArrows(swiper) {
        if (!prevArrow || !nextArrow) return;
        if (swiper.isLocked) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
          return;
        }
        prevArrow.style.display = '';
        nextArrow.style.display = '';
        prevArrow.disabled = swiper.isBeginning;
        nextArrow.disabled = swiper.isEnd;
      }

      function build() {
        if (!window.Swiper) return;
        var lg = parseFloat(grid.getAttribute('data-slides-lg')) || 4;
        var gutter = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter')) || 16;
        var swiper = new Swiper(grid, {
          slidesPerView: 1,
          spaceBetween: gutter,
          watchOverflow: true,
          breakpoints: {
            1000: { slidesPerView: lg, spaceBetween: gutter }
          }
        });
        swiper.on('slideChange', function() { updateArrows(swiper); });
        swiper.on('reachBeginning', function() { updateArrows(swiper); });
        swiper.on('reachEnd', function() { updateArrows(swiper); });
        swiper.on('fromEdge', function() { updateArrows(swiper); });
        updateArrows(swiper);

        if (prevArrow) prevArrow.addEventListener('click', function() { swiper.slidePrev(); });
        if (nextArrow) nextArrow.addEventListener('click', function() { swiper.slideNext(); });
      }

      build();
    }

    document.querySelectorAll('.shopify-section--ukj-trust').forEach(function(section) {
      initTrustSlider(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
